var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPlcFabricColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00024 9.864H59.0822V6H4.00024V9.864Z",
    fill: "#F9B233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16.5066H59.082V12.6426H4V16.5066Z",
    fill: "#F9B233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 23.1501H59.082V19.2861H4V23.1501Z",
    fill: "#F9B233"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 29.7942H59.082V25.9302H4V29.7942Z",
    fill: "#F9B233"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 36.4363H59.082V32.5723H4V36.4363Z",
    fill: "#F9B233"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 43.0798H59.082V39.2158H4V43.0798Z",
    fill: "#F9B233"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 49.7234H59.082V45.8594H4V49.7234Z",
    fill: "#F9B233"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 49.7693H7.73272V49.7234H4V49.7693ZM4 45.8585H7.73272V43.0796H4V45.8585ZM4 39.2156H7.73272V36.4367H4V39.2156ZM4 32.5727H7.73272V29.7938H4V32.5727ZM4 25.9289H7.73272V23.15H4V25.9289ZM4 19.286H7.73272V16.5071H4V19.286ZM4 12.6431H7.73272V9.86426H4V12.6431Z",
    fill: "#FCD898"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00024 9.864H7.73297V6H4.00024V9.864Z",
    fill: "#F9B233"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16.5066H7.73272V12.6426H4V16.5066Z",
    fill: "#F9B233"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 23.1501H7.73272V19.2861H4V23.1501Z",
    fill: "#F9B233"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 29.7942H7.73272V25.9302H4V29.7942Z",
    fill: "#F9B233"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 36.4363H7.73272V32.5723H4V36.4363Z",
    fill: "#F9B233"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 43.0798H7.73272V39.2158H4V43.0798Z",
    fill: "#F9B233"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 49.7234H7.73272V45.8594H4V49.7234Z",
    fill: "#F9B233"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4182 49.7693H14.1519V49.7234H10.4182V49.7693ZM10.4182 45.8585H14.1519V43.0796H10.4182V45.8585ZM10.4182 39.2156H14.1519V36.4367H10.4182V39.2156ZM10.4182 32.5727H14.1519V29.7938H10.4182V32.5727ZM10.4182 25.9289H14.1519V23.15H10.4182V25.9289ZM10.4182 19.286H14.1519V16.5071H10.4182V19.286ZM10.4182 12.6431H14.1519V9.86426H10.4182V12.6431Z",
    fill: "#FCD898"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4182 9.864H14.1519V6H10.4182V9.864Z",
    fill: "#F9B233"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4182 16.5066H14.1519V12.6426H10.4182V16.5066Z",
    fill: "#F9B233"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4182 23.1501H14.1519V19.2861H10.4182V23.1501Z",
    fill: "#F9B233"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4182 29.7942H14.1519V25.9302H10.4182V29.7942Z",
    fill: "#F9B233"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4182 36.4363H14.1519V32.5723H10.4182V36.4363Z",
    fill: "#F9B233"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4182 43.0798H14.1519V39.2158H10.4182V43.0798Z",
    fill: "#F9B233"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4182 49.7234H14.1519V45.8594H10.4182V49.7234Z",
    fill: "#F9B233"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8369 49.7693H20.5706V49.7234H16.8369V49.7693ZM16.8369 45.8585H20.5706V43.0796H16.8369V45.8585ZM16.8369 39.2156H20.5706V36.4367H16.8369V39.2156ZM16.8369 32.5727H20.5706V29.7938H16.8369V32.5727ZM16.8369 25.9289H20.5706V23.15H16.8369V25.9289ZM16.8369 19.286H20.5706V16.5071H16.8369V19.286ZM16.8369 12.6431H20.5706V9.86426H16.8369V12.6431Z",
    fill: "#FCD898"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8369 9.864H20.5706V6H16.8369V9.864Z",
    fill: "#F9B233"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8369 16.5066H20.5706V12.6426H16.8369V16.5066Z",
    fill: "#F9B233"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8369 23.1501H20.5706V19.2861H16.8369V23.1501Z",
    fill: "#F9B233"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8369 29.7942H20.5706V25.9302H16.8369V29.7942Z",
    fill: "#F9B233"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8369 36.4363H20.5706V32.5723H16.8369V36.4363Z",
    fill: "#F9B233"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8369 43.0798H20.5706V39.2158H16.8369V43.0798Z",
    fill: "#F9B233"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8369 49.7234H20.5706V45.8594H16.8369V49.7234Z",
    fill: "#F9B233"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2559 49.7693H26.9895V49.7234H23.2559V49.7693ZM23.2559 45.8585H26.9895V43.0796H23.2559V45.8585ZM23.2559 39.2156H26.9895V36.4367H23.2559V39.2156ZM23.2559 32.5727H26.9895V29.7938H23.2559V32.5727ZM23.2559 25.9289H26.9895V23.15H23.2559V25.9289ZM23.2559 19.286H26.9895V16.5071H23.2559V19.286ZM23.2559 12.6431H26.9895V9.86426H23.2559V12.6431Z",
    fill: "#FCD898"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2559 9.864H26.9895V6H23.2559V9.864Z",
    fill: "#F9B233"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2559 16.5066H26.9895V12.6426H23.2559V16.5066Z",
    fill: "#F9B233"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2559 23.1501H26.9895V19.2861H23.2559V23.1501Z",
    fill: "#F9B233"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2559 29.7942H26.9895V25.9302H23.2559V29.7942Z",
    fill: "#F9B233"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2559 36.4363H26.9895V32.5723H23.2559V36.4363Z",
    fill: "#F9B233"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2559 43.0798H26.9895V39.2158H23.2559V43.0798Z",
    fill: "#F9B233"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2559 49.7234H26.9895V45.8594H23.2559V49.7234Z",
    fill: "#F9B233"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6738 49.7693H33.4075V49.7234H29.6738V49.7693ZM29.6738 45.8585H33.4075V43.0796H29.6738V45.8585ZM29.6738 39.2156H33.4075V36.4367H29.6738V39.2156ZM29.6738 32.5727H33.4075V29.7938H29.6738V32.5727ZM29.6738 25.9289H33.4075V23.15H29.6738V25.9289ZM29.6738 19.286H33.4075V16.5071H29.6738V19.286ZM29.6738 12.6431H33.4075V9.86426H29.6738V12.6431Z",
    fill: "#FCD898"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6738 9.864H33.4075V6H29.6738V9.864Z",
    fill: "#F9B233"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6738 16.5066H33.4075V12.6426H29.6738V16.5066Z",
    fill: "#F9B233"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6738 23.1501H33.4075V19.2861H29.6738V23.1501Z",
    fill: "#F9B233"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6738 29.7942H33.4075V25.9302H29.6738V29.7942Z",
    fill: "#F9B233"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6738 36.4363H33.4075V32.5723H29.6738V36.4363Z",
    fill: "#F9B233"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6738 43.0798H33.4075V39.2158H29.6738V43.0798Z",
    fill: "#F9B233"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6738 49.7234H33.4075V45.8594H29.6738V49.7234Z",
    fill: "#F9B233"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0928 49.7693H39.8264V49.7234H36.0928V49.7693ZM36.0928 45.8585H39.8264V43.0796H36.0928V45.8585ZM36.0928 39.2156H39.8264V36.4367H36.0928V39.2156ZM36.0928 32.5727H39.8264V29.7938H36.0928V32.5727ZM36.0928 25.9289H39.8264V23.15H36.0928V25.9289ZM36.0928 19.286H39.8264V16.5071H36.0928V19.286ZM36.0928 12.6431H39.8264V9.86426H36.0928V12.6431Z",
    fill: "#FCD898"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0928 9.864H39.8264V6H36.0928V9.864Z",
    fill: "#F9B233"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0928 16.5066H39.8264V12.6426H36.0928V16.5066Z",
    fill: "#F9B233"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0928 23.1501H39.8264V19.2861H36.0928V23.1501Z",
    fill: "#F9B233"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0928 29.7942H39.8264V25.9302H36.0928V29.7942Z",
    fill: "#F9B233"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0928 36.4363H39.8264V32.5723H36.0928V36.4363Z",
    fill: "#F9B233"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0928 43.0798H39.8264V39.2158H36.0928V43.0798Z",
    fill: "#F9B233"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0928 49.7234H39.8264V45.8594H36.0928V49.7234Z",
    fill: "#F9B233"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5117 49.7693H46.2454V49.7234H42.5117V49.7693ZM42.5117 45.8585H46.2454V43.0796H42.5117V45.8585ZM42.5117 39.2156H46.2454V36.4367H42.5117V39.2156ZM42.5117 32.5727H46.2454V29.7938H42.5117V32.5727ZM42.5117 25.9289H46.2454V23.15H42.5117V25.9289ZM42.5117 19.286H46.2454V16.5071H42.5117V19.286ZM42.5117 12.6431H46.2454V9.86426H42.5117V12.6431Z",
    fill: "#FCD898"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5117 9.864H46.2454V6H42.5117V9.864Z",
    fill: "#F9B233"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5117 16.5066H46.2454V12.6426H42.5117V16.5066Z",
    fill: "#F9B233"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5117 23.1501H46.2454V19.2861H42.5117V23.1501Z",
    fill: "#F9B233"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5117 29.7942H46.2454V25.9302H42.5117V29.7942Z",
    fill: "#F9B233"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5117 36.4363H46.2454V32.5723H42.5117V36.4363Z",
    fill: "#F9B233"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5117 43.0798H46.2454V39.2158H42.5117V43.0798Z",
    fill: "#F9B233"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5117 49.7234H46.2454V45.8594H42.5117V49.7234Z",
    fill: "#F9B233"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9294 49.7693H52.6631V49.7234H48.9294V49.7693ZM48.9294 45.8585H52.6631V43.0796H48.9294V45.8585ZM48.9294 39.2156H52.6631V36.4367H48.9294V39.2156ZM48.9294 32.5727H52.6631V29.7938H48.9294V32.5727ZM48.9294 25.9289H52.6631V23.15H48.9294V25.9289ZM48.9294 19.286H52.6631V16.5071H48.9294V19.286ZM48.9294 12.6431H52.6631V9.86426H48.9294V12.6431Z",
    fill: "#FCD898"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9294 9.864H52.6631V6H48.9294V9.864Z",
    fill: "#F9B233"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9294 16.5066H52.6631V12.6426H48.9294V16.5066Z",
    fill: "#F9B233"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9294 23.1501H52.6631V19.2861H48.9294V23.1501Z",
    fill: "#F9B233"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9294 29.7942H52.6631V25.9302H48.9294V29.7942Z",
    fill: "#F9B233"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9294 36.4363H52.6631V32.5723H48.9294V36.4363Z",
    fill: "#F9B233"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9294 43.0798H52.6631V39.2158H48.9294V43.0798Z",
    fill: "#F9B233"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9294 49.7234H52.6631V45.8594H48.9294V49.7234Z",
    fill: "#F9B233"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.082 49.769H55.3484V49.7231H59.082V45.8591H55.3484V43.0793H59.082V39.2153H55.3484V36.4365H59.082V32.5725H55.3484V29.7936H59.082V25.9296H55.3484V23.1498H59.082V19.2858H55.3484V16.5069H59.082V12.6429H55.3484V9.864H59.082V6V49.769Z",
    fill: "#FCD898"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3484 9.864H59.082V6H55.3484V9.864Z",
    fill: "#F9B233"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3484 16.5066H59.082V12.6426H55.3484V16.5066Z",
    fill: "#F9B233"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3484 23.1501H59.082V19.2861H55.3484V23.1501Z",
    fill: "#F9B233"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3484 29.7942H59.082V25.9302H55.3484V29.7942Z",
    fill: "#F9B233"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3484 36.4363H59.082V32.5723H55.3484V36.4363Z",
    fill: "#F9B233"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3484 43.0798H59.082V39.2158H55.3484V43.0798Z",
    fill: "#F9B233"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3484 49.7234H59.082V45.8594H55.3484V49.7234Z",
    fill: "#F9B233"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 58.4546H5.86636V49.7231H4V58.4546Z",
    fill: "#F9B233"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09351 58.4546H9.95987V49.7231H8.09351V58.4546Z",
    fill: "#F9B233"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1873 58.4546H14.0536V49.7231H12.1873V58.4546Z",
    fill: "#F9B233"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2805 58.4546H18.1469V49.7231H16.2805V58.4546Z",
    fill: "#F9B233"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.374 58.4546H22.2404V49.7231H20.374V58.4546Z",
    fill: "#F9B233"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4673 58.4546H26.3336V49.7231H24.4673V58.4546Z",
    fill: "#F9B233"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5603 58.4546H30.4276V49.7231H28.5603V58.4546Z",
    fill: "#F9B233"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6536 58.4546H34.5208V49.7231H32.6536V58.4546Z",
    fill: "#F9B233"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7473 58.4546H38.6146V49.7231H36.7473V58.4546Z",
    fill: "#F9B233"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8408 58.4546H42.7081V49.7231H40.8408V58.4546Z",
    fill: "#F9B233"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9346 58.4546H46.8018V49.7231H44.9346V58.4546Z",
    fill: "#F9B233"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0278 58.4546H50.8951V49.7231H49.0278V58.4546Z",
    fill: "#F9B233"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1213 58.4546H54.9886V49.7231H53.1213V58.4546Z",
    fill: "#F9B233"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2148 58.4546H59.0821V49.7231H57.2148V58.4546Z",
    fill: "#F9B233"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlcFabricColored);
export default __webpack_public_path__ + "static/media/ic_plc_fabric_colored.37c6836e5c427f4f7e044c119ea60868.svg";
export { ForwardRef as ReactComponent };